module.exports = __webpack_public_path__ + "947f581acfa7256d8b74a4667e100b20.svg";